import { FunctionComponent } from "react";
import NAV from "../components/NAV";
import TeamCard from "../components/TeamCard";

const Haveli: FunctionComponent = () => {
  return (
    <div className="self-stretch relative accurate overflow-hidden flex flex-col items-center justify-center pt-[2.38rem] px-[0rem] pb-[0rem] box-border gap-[4.69rem] text-center text-[2rem] text-lavenderblush-100 font-anek-devanagari">
      <div className="self-stretch flex flex-col items-center justify-center py-[0rem] px-[2.13rem] gap-[3.13rem]">
        <NAV />
        <div className=" self-stretch flex flex-col items-center justify-center py-[0rem] max-md:px-[2rem] px-[10.63rem] max-md:px-20 gap-[3.63rem] text-white">
          <img
            className="w-[41.94rem] relative h-[11.44rem] max-md:w-[25rem] max-md:h[1rem] "
            alt=""
            src="/image-202@2x.png"
          />
          <div className="text-transparent  !bg-clip-text max-md:text-[1.5rem] [background:linear-gradient(180deg,_#ffeee9,_#ffbca8)] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]">
            A closed group of 150 Indian traders and investors wandering the
            world of NFTs and crypto, helping each other climb ladders
          </div>
          <div className="flex flex-row max-md:flex-col items-center justify-center gap-[2.88rem] text-[1.88rem]">
            <a href="https://discord.gg/t7VeQBNmsE" target="_blank" className="text-white no-underline">
            <div className="rounded-981xl butt bg-gray-200 flex flex-col items-center justify-center py-[0.5rem] px-[4.88rem] border-[1px] border-solid border-goldenrod-100">
              <div className=" relative font-medium inline-block h-[2.63rem] shrink-0">
                Discord
              </div>
            </div>
            </a>
            <a href="https://twitter.com/ThehaveliDao" target="_blank" className="text-white no-underline">
            <div className="rounded-981xl butt bg-gray-200 flex flex-col items-center justify-center py-[0.5rem] px-[4.88rem] border-[1px] border-solid border-goldenrod-100">
              <div className=" relative font-medium inline-block h-[2.63rem] shrink-0">
                Twitter
              </div>
            </div>
            </a>
          </div>
        </div>
        <div id="aboutUs" className=" flex max-md:flex-col max-md:text-center flex-row items-center justify-center pt-[5.25rem] max-md:px-[2rem] px-[8.63rem] max-md:px-[1rem] pb-[0rem] gap-[7.75rem] text-left text-[2.19rem]">
          <div className="flex-1 flex flex-col items-start max-md:items-center justify-center gap-[2.81rem]">
            <div className=" relative font-semibold">About Us</div>
            <div className="relative text-[1.44rem] font-medium text-snow">
              Haveli Dao is a group that came out of a bunch of pessies who
              wanted to make alot of money but had no place to go with this
              goal, they created Haveli DAO
            </div>
            <a href="#team" className="no-underline">
            <div className="rounded-981xl butt bg-gray-200 flex w-fit flex-col items-center justify-center py-[0.5rem] px-[4.88rem] text-center text-[1.63rem] max-md:px-[2rem] text-lavenderblush-200 border-[1px] border-solid border-goldenrod-100">
              <div className=" no unrelative font-medium inline-block h-[2.19rem] shrink-0">
                Meet The Team
              </div>
            </div>
            </a>
          </div>
          <img
            className="w-[17.63rem] relative rounded-[33px] h-[17.63rem] object-cover"
            alt=""
            src="/image-204@2x.png"
          />
        </div>
        <div id="team" className="w-full flex flex-col items-center justify-start pt-[8.19rem] px-[8.63rem] pb-[10.38rem] gap-[4.69rem] text-[2.5rem] ">
          <div className="relative font-semibold inline-block h-[2.56rem] shrink-0">
            Meet The Team
          </div>
          <div className="self-stretch flex-1 flex-grid max-md:flex-col tweak flex flex-row items-center justify-center gap-[4.69rem]">
            <TeamCard
              userDescription1="https://media.discordapp.net/attachments/874259441384574976/1204352947421712404/image.png?ex=65d46c16&is=65c1f716&hm=28b53006c111802b03de4bbd3e76946f6e220ef55f7748643b48d9644377c5b7&=&format=webp&quality=lossless&width=463&height=460"
              userImageUrl="Broken"
              userRole="Web2 entrepreneur dabbling with web3 investments and trading, jack of all"
              jobTitle="Founder & CEO"
            />
            <TeamCard
              userDescription1="https://media.discordapp.net/attachments/874259441384574976/1204352994989051935/image.png?ex=65d46c21&is=65c1f721&hm=32f51429a158f90a6d00722cc115703cda793c477ec540fa5cf3c6562d9428ae&=&format=webp&quality=lossless&width=463&height=460"
              userImageUrl="Otaku"
              userRole="A random otaku on the blockchain providing insights with threads"
              jobTitle="Co-Founder"
            />
            <TeamCard
              userDescription1="https://media.discordapp.net/attachments/1166043008056164422/1203634372398293053/IMG_2072.png?ex=65d1cedc&is=65bf59dc&hm=604863a1384925a8380e0a07386f4e0491988fb3fcf8a5cae9d227cb397b2791&=&format=webp&quality=lossless&width=603&height=603"
              userImageUrl="Nexus"
              userRole="A 20yo guy started from making thumbnails for youtubers and ended up landing into web3 ."
              jobTitle="Co-Founder & Designer"
            />
            <TeamCard
              userDescription1="https://media.discordapp.net/attachments/1166043008056164422/1195336119110348830/yytf3Ef_400x400.png?ex=65cf4e03&is=65bcd903&hm=cf394c353f1ccdcaaf52c403eaf05da793a44d489a64a05c97aeaa79ff497008&=&format=webp&quality=lossless&width=450&height=450"
              userImageUrl="Oxig"
              userRole="school dropout turned demon trader, plays games and watches charts."
              jobTitle="Co-Founder"
            />
          </div>
          <div className="self-stretch max-md:flex-col flex flex-row items-center justify-center gap-[4.69rem]">
            <TeamCard
              userDescription1="https://media.discordapp.net/attachments/1166043008056164422/1204486555717083257/IMG_2163.png?ex=65d4e885&is=65c27385&hm=d2a8cbf23902fc7ccae572139d692554e24227196d47868c88aed953fb28da82&=&format=webp&quality=lossless&width=603&height=603"
              userImageUrl="Manali"
              userRole="Travel, creatives and content stratergy"
              jobTitle="Creative Director "
            />
            <TeamCard
              userDescription1="https://media.discordapp.net/attachments/1166043008056164422/1204487141611278336/IMG_2032.png?ex=65d4e910&is=65c27410&hm=6ceda6e542aeb3b91c9b49860974bd673727a2d4b3a3c8f0549ddaa98cf5dbe5&=&format=webp&quality=lossless&width=603&height=603"
              userImageUrl="Nikamma "
              userRole="Nikamma is a sol maxi through and through, engaging with the ecosystem for over 2 years."
              jobTitle="Grindoor"
            />
           
          </div>
        </div>
      </div>
      <div className="self-stretch justify-between max-md:flex-col max-md:items-center max-md:justify-center max-md:w-full max-md:pt-[2rem] h-full max-md:justify-center [background:linear-gradient(263.58deg,_rgba(0,_0,_0,_0.14)_17.17%,_rgba(255,_0,_0,_0.09))] h-[18.38rem] flex flex-row items-center justify-end gap-[0.63rem] text-[2.5rem]">
        <div className="flex-1 flex flex-col items-start max-md:items-center justify-center py-[0rem] px-[6.5rem] gap-[3rem]">
          <div className="max-md:text-[1.5rem] max-md:mt-4 relative font-semibold inline-block h-[2.56rem] shrink-0">
            Home For Web3 Desis
          </div>
          <div className="flex flex-row items-center justify-start gap-[3.69rem]">
          <a href="https://discord.gg/t7VeQBNmsE" target="_blank" className="text-white no-underline">
            <div className="rounded-smi cursor-pointer bg-salmon overflow-hidden flex flex-row items-center justify-center py-[0.88rem] px-[1.5rem] border-[3px] border-solid border-tomato">
              <img
                className="w-[2.81rem] relative h-[2.81rem] object-cover"
                alt=""
                src="/discord-new@2x.png"
              />
            </div>
            </a>
            <a href="https://twitter.com/ThehaveliDao" target="_blank" className="text-white no-underline">
            <div className="rounded-smi cursor-pointer bg-salmon overflow-hidden flex flex-row items-center justify-center py-[0.88rem] px-[1.5rem] border-[3px] border-solid border-tomato">
              <img
                className="w-[2.81rem] relative h-[2.81rem] object-cover"
                alt=""
                src="/twitterx@2x.png"
              />
            </div>
            </a>
          </div>
        </div>
        <div className="items-end max-md:items-center">
        <img
          className=" w-[20.4rem]   object-cover"
          alt=""
          src="/image-206@2x.png"
        /></div>
      </div>
    </div>
  );
};

export default Haveli;
